import { useTranslation } from 'react-i18next';
import { ErrorResultA11y } from './ErrorResultA11y.tsx';
import { type IErrorResultBodyProps } from './ErrorResultBody.tsx';
import { OnPageResultContainer } from './OnPageResultContainer.tsx';

/**
 * Props condivise tra i componenti di errore.
 */
export function NotFoundBody(props: IErrorResultBodyProps) {
  const { message, description, title } = props;
  const { t } = useTranslation();

  return (
    <OnPageResultContainer>
      <ErrorResultA11y
        status="error"
        title={title ?? t('alert.not-found-body.title', '404 Non Trovato')}
        subTitle={
          message ?? t('alert.not-found-body.subtitle', 'Pagina Non Trovata.')
        }
        extra={description}
      />
    </OnPageResultContainer>
  );
}
